import { useState } from "react";
import ActionSheet from "../ActionSheet";
import { MeetingSharesItem } from "@/types/share";
import { RoleTextMap, RoleType } from "@/constants/share";
import ArrowDownIcon from "@/assets/common/ic_select_arrow_down.svg?react";
import ArrowUpIcon from "@/assets/common/ic_select_arrow_up.svg?react";

type PermissionOption = {
  id: RoleType;
  label: string;
};

const permissionOptions: PermissionOption[] = [
  { id: RoleType.Manager, label: RoleTextMap[RoleType.Manager] },
  { id: RoleType.Viewer, label: RoleTextMap[RoleType.Viewer] },
  // { id: RoleType.Removed, label: RoleTextMap[RoleType.Removed] }
];

function RightsSheet(props: {
  user: MeetingSharesItem;
  editable: boolean;
  onChange?: (value: MeetingSharesItem) => void;
}) {
  const { user, editable, onChange } = props;
  const [visible, setVisible] = useState(false);

  const handleChoose = (value: RoleType) => {
    if (value !== user.sharePermission) {
      onChange?.({ ...user, sharePermission: value });
    }
    setVisible(false);
  };

  const clickHandle = () => {
    if (!editable) return;
    setVisible(true);
  }

  return (
    <>
      <div className="flex items-center text-#626773 text-size-3.5" onClick={clickHandle}>
        <div>{RoleTextMap[user.sharePermission]}</div>
        {editable && (visible ? <ArrowUpIcon className="m-l-2 w-4 h-4" /> : <ArrowDownIcon className="m-l-2 w-4 h-4" />)}
      </div>
      <ActionSheet
        visible={visible}
        title={user.name}
        contentClassName="p-y-4"
        onClose={() => setVisible(false)}
      >
        {permissionOptions.map((item) => (
          <div
            key={item.id}
            className={`h-12.5 text-align-center color-mx-secondary text-size-4 line-height-12.5 active:op-60 active:bg-mx-black active:bg-op-05 
              ${item.id === RoleType.Removed ? "color-mx-error" : ""}`}
            onClick={() => handleChoose(item.id)}
          >
            {item.label}
          </div>
        ))}
      </ActionSheet>
    </>
  );
}

export default RightsSheet;
